var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flix-text-right"},[_c('b-flix-button',{attrs:{"variant":"text","callback":_vm.getData}},[_vm._v("Download CSV")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }